import type { LandingSurface } from '@/types/client-landing'
import { AppLandingSectionRenderer } from '@/landing/blocks/app-landing-blocks'
import {
  MarketingLandingSectionRenderer,
} from '@/landing/blocks/marketing-landing-blocks'

export type LandingSectionRendererProps = {
  section: import('@/types/client-landing').LandingSection
  sectionIndex: number
  surface?: LandingSurface
}

export { getMarketingSectionBandProps } from '@/landing/blocks/marketing-landing-blocks'

export function LandingSectionRenderer({
  section,
  sectionIndex,
  surface = 'app',
}: LandingSectionRendererProps) {
  if (surface === 'marketing') {
    return <MarketingLandingSectionRenderer section={section} />
  }
  return <AppLandingSectionRenderer section={section} sectionIndex={sectionIndex} />
}
